import React, { createContext, useContext, useState } from 'react';

export const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(
    () => localStorage.getItem('tc_theme') || 'dark'
  );
  const toggle = () =>
    setTheme(t => {
      const next = t === 'dark' ? 'light' : 'dark';
      localStorage.setItem('tc_theme', next);
      return next;
    });
  return (
    <ThemeContext.Provider value={{ theme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}

// ── Design tokens — import this in any page ──────────────────────────────────
export const TOKENS = {
  dark: {
    bg:           '#08090e',
    bgAlt:        '#0c0d14',
    card:         '#0f1117',
    cardHover:    '#13151f',
    border:       '#1c1e2a',
    borderHover:  '#2a2d3e',
    accent:       '#4f8ef7',
    accentBg:     '#0d1528',
    accentBorder: '#1e3a6e',
    text:         '#e8eaf0',
    secondary:    '#6b7280',
    muted:        '#374151',
    success:      '#10b981',
    warning:      '#f59e0b',
    error:        '#f87171',
    navBg:        'rgba(8,9,14,0.85)',
    shadow:       '0 0 0 1px rgba(79,142,247,0.08)',
  },
  light: {
    bg:           '#f5f6fa',
    bgAlt:        '#eef0f6',
    card:         '#ffffff',
    cardHover:    '#f8f9fd',
    border:       '#e2e5ef',
    borderHover:  '#c5cce0',
    accent:       '#2d6ff0',
    accentBg:     '#eef3fe',
    accentBorder: '#c3d5fb',
    text:         '#0d1117',
    secondary:    '#5a6474',
    muted:        '#c0c6d4',
    success:      '#059669',
    warning:      '#d97706',
    error:        '#dc2626',
    navBg:        'rgba(245,246,250,0.88)',
    shadow:       '0 1px 3px rgba(0,0,0,0.06)',
  },
};